<template>
  <div class="wrap">
    <header>
      <img src="../assets/banner8.png" alt="">
    </header>
    <div class="headline">
      <p>联系方式</p>
      <span></span>
    </div>
    <div class="content">
      <div class="tit">
        中国数据处理中心
        <div></div>
      </div>
      <div class="cont">
        <!-- <p>客服电话（中国）:</p> -->
        <p>{{ commonData?commonData.tel[0].content:'' }}</p>
        <div style="display: flex;">
          <div>
            <p>中国=>澳洲 日本 美国等集运业务（速派集运|随意邮）</p>
            <div></div>
            <p>澳洲=>中国快件业务（fastgo速派快递）</p>
          </div>
          <div>
            <p>北京时间 周一~周五 8：00~18：00</p>
            <div></div>
            <p>北京时间 周一~周五 8：00~17：00</p>
          </div>
        </div>
        <p>中国及海外节日会根据业务需要安排值班</p>
      </div>
      <div class="tit">
        澳大利亚运营中心
        <div></div>
      </div>
      <div class="contant">
        <div class="contLeft">
          <div class="cont">
            <p>邮 箱: service@fastgo.com.au</p>
            <p>布里斯班操作中心：</p>
            <p>Unit 3, 17Learoyd Road, Acacia Ridge </p>
          </div>
        </div>
        <div class="contRight">
          <div class="cont">
            <!-- <p>澳洲仓库：04 1639 3828 </p> -->
            <p>澳洲仓库：049 105 8008</p>
            <p>工作时间：09:00-16:00（澳洲时间）Monday-Friday</p>
            <p>服务范围：收发货/预定包装材料/仓库疑难件</p>
          </div>
        </div>
      </div>
      <div class="contant">
        <div class="contLeft">
          <div class="cont">
            <!-- <p>澳洲客服：07 3103 2666</p> -->
            <p>澳洲客服：049 105 8008</p>
            <p>工作时间：10:30-19:30(澳洲时间) Monday-Friday</p>
            <p>服务范围：身份证/信息修改/包裹追踪/包裹改派</p>
          </div>
        </div>
        <div class="contRight">
          <div class="cont">
            <p>售后服务：049 105 8008</p>
            <p>工作时间：10:30-19:30（澳洲时间）Monday-Friday</p>
            <p>服务范围：投诉/建议/赔付</p>
          </div>
        </div>
      </div>
      <div class="tit">
        加拿大运营中心
        <div></div>
      </div>
      <div class="cont">
        <p>客服电话：604-270-8680转4</p>
        <p>周一~周五12:00~19:00(温哥华时间)</p>
      </div>
      <div class="eg">
        <p>温哥华操作中心:</p>
        <div class="contant">
          <div class="contLeft">
            <div class="cont">
              <p>#110-13431 Maycrest Way,Richmond,BC,V6V,2M3</p>
              <P>Tel:604-270-8680转1</P>
              <p>工作时间：周一至周五9:00~17:00(温哥华时间)</p>
            </div>
            <div class="cont">
              <p>1108-4500 Kingsway,Burnaby,BC,V5H2A9</p>
              <P>Tel:604-270-8680转2</P>
              <p>工作时间：周一至周五10:30~18:30</p>
              <P class="nbsp">周六、周日11:00-17:30(温哥华时间)</P>
            </div>
            <div class="cont">
              <p>列治文三号路直营点</p>
              <p>1445-4540 No.3 Road,Richmond,BC,V6Y2C2</p>
              <P>Tel:604-270-8680转3</P>
              <p>工作时间：周一至周五11:00~19:00</p>
              <P class="nbsp">周六、周日11:00-18:00(温哥华时间)</P>
            </div>
            <div class="cont">
              <P>高贵林加盟点</P>
              <p>102A-3020 Lincoln Ave,Coquitlam,BC</p>
              <P>Tel:604-270-8680转5</P>
            </div>
            <div class="cont">
              <P>Surrey加盟点：</P>
              <p>15357 104-Ave,Sueery,BC V3R 1N5</p>
              <p>Hannam超市内</p>
              <P>Tel:604-270-8680转6</P>
            </div>
          </div>
          <div class="contRight">
            <div class="cont">
              <p>维多利亚加盟点</p>
              <p>218-1595 Mckenzie Ave,Victoria,BC</p>
              <P>Tel:778-85336068</P>
            </div>
            <div class="cont">
              <p>卡尔加里代理点</p>
              <p>3441 12 St Ne Calgary T2E 6S6</p>
              <P>Tel：403-230-8166</P>
            </div>
            <div class="cont">
              <p>埃德蒙顿代理点</p>
              <P>Tel：780-707-9718</P>
            </div>
            <div class="cont">
              <p>萨斯卡通代理点</p>
              <p>2723 Faithfull Ave,Saskatoon.Saskatchewan</p>
              <P>Tel：306-227-5838</P>
            </div>
            <div class="cont">
              <p>多伦多代理点</p>
              <p>Unit25 290 Yorktech Dr., Markham,ON,L6G 0A7</p>
              <P>Tel：9056048700 Fax:9057661966</P>
            </div>
          </div>
        </div>
      </div>
      <div class="tit">
        新西兰运营中心
        <div></div>
      </div>
      <div class="cont">
        <p>奥克兰操作中心</p>
        <p>7/180 Montgomerie,Mangere,Auckland,New Zealand,2022</p>
        <p>Tel:+64 9 2560268</p>
        <p>Fax:+65 9 2560158</p>
      </div>
      <div class="tit">
        美国运营中心
        <div></div>
      </div>
      <div class="cont">
        <p>公司名称：FASTGO LLC</p>
        <p>14145 Proctor Ave Unit 21 & 22 La Puente, CA 91746</p>
        <p>Tel:+1 323 703 1615</p>
      </div>
      <div class="tit">
        日本运营中心
        <div></div>
      </div>
      <div class="cont">
        <p>公司名称：東朝株式会社</p>
        <p>〒583-0884　大阪府羽曳野市野350-1</p>
        <p>TEL：080-3789-2680</p>
        <p>FAX：06-7710-2846</p>
      </div>
      <!--<div class="tit">-->
      <!--澳大利亚悉尼处理中心-->
      <!--<div></div>-->
      <!--</div>-->
      <!--<div class="cont sydneyCode">-->
      <!--<p>国家地区：澳大利亚 悉尼</p>-->
      <!--&lt;!&ndash;<p>电话：0466 051 033</p>&ndash;&gt;-->
      <!--<p>邮编：2200</p>-->
      <!--<p>地址：9 Homedale Rd. Bankstown</p>-->
      <!--<p>周一到周六 9:00 - 6:00 pm</p>-->
      <!--<div class="sydneyService">-->
      <!--<img src="../assets/syd.png" alt="">-->
      <!--<div>悉尼处理中心客服</div>-->
      <!--</div>-->

      <!--</div>-->
      <div class="relation">
        <div class="call">
          <p>为了更快解答您的问题，建议您直接拨打我们的客服热线：（中国）{{ commonData?commonData.tel[0].content:'' }}</p>
          <p>或者关注我司微信公众号{{ commonData?commonData.fastgoCode[0].content:'' }}进行查询和咨询,谢谢！</p>
        </div>
        <dl>
          <dt>
            <img :src="commonData?commonData.fastgoCode[0].logo_url:''" alt="">
          </dt>
          <dd>关注公众号开始寄件服务</dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex'

  export default {
    name: 'ContactUs',
    props: {},
    components: {},
    data() {
      return {}
    },
    computed: {
      ...mapState({
        commonData: state => state.commonData,
      }),
    },
    methods: {},
    created() {

    },
    mounted() {

    }
  }
</script>
<style scoped lang="scss">
  .headline {
    width: 1000px;
    margin: 20px auto;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    p {
      font-weight: 600;
      font-size: 24px;
    }

    span {
      width: 50px;
      height: 3px;
      background: $bg-color;
    }
  }

  P {
    font-size: 18px;
    margin: 5px 0;
    color: #484848;
  }

  .nbsp {
    text-indent: 2em;
  }

  .content {
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 50px;
    box-sizing: border-box;
    background: url(../assets/backimg5.png) no-repeat 0 115%;
    background-size: 100% 28%;

    .tit {
      font-size: 21px;
      border-bottom: 1px solid #a6a6a6;
      height: 50px;
      line-height: 50px;
      color: #333333;

      div {
        width: 43px;
        height: 3px;
        background: $bg-color;
      }
    }

    .cont {
      margin: 15px 0;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .contant {
      display: flex;
      flex-wrap: wrap;

      >div {
        flex: 1;
      }
    }

    .eg {
      border-top: 1px dashed #a6a6a6;

      >p {
        margin-bottom: -10px;
        margin-top: 20px;
      }
    }

    .relation {
      display: flex;
      justify-content: space-between;

      .call {
        height: 81px;
        background: #474747;
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 25px;
        padding: 0 40px;
        box-sizing: border-box;

        p {
          color: #fff;
          font-size: 15px;
          margin: 6px 0;
        }
      }

      dl {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        dt {
          img {
            width: 170px;
            height: 170px;
          }
        }

        dd {
          font-size: 13px;
          color: $bg-color;
        }
      }
    }
  }

  .sydneyService {
    position: absolute;
    right: 10px;
    text-align: center;
  }

  .sydneyService img {
    width: 150px;
  }

  .sydneyCode {
    height: 180px;
  }
</style>


// WEBPACK FOOTER //
// src/view/ContactUs.vue